export const portfolioText = {
  en: {
    title: "Portfolio",
    coin: "Coin",
    quantity: "Quantity",
    value: "Value(USD)",
  },
  tr: {
    title: "Portfolyo",
    coin: "Coin",
    quantity: "Miktar",
    value: "Değer(USD)",
  },
};
